<script>
export default {
  methods: {
    showMore() {
      this.$emit('show-more');
    },
  },
};
</script>

<template>
  <div class="row mt-5">
    <div class="col-12 text-center">
      <button @click="showMore" class="button-small">Visa fler</button>
    </div>
  </div>
</template>
